<template>
  <v-navigation-drawer :clipped="$vuetify.breakpoint.lgAndUp" app>
    <v-list dense>
      <template v-for="item in menu">
        <template v-if="!item.onlyAdmin || isAdmin">
          <v-list-group
            v-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon=""
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item-group class="grey lighten-4">
              <v-list-item
                v-for="(child, index) in item.children"
                :key="child.id"
                link
                :inactive="inactive"
                @click="changeItem(index)"
                :class="{
                  'v-list-item--active': itemIndex === index
                }"
              >
                <v-list-item-action>
                  <v-icon>{{ child.icon ? child.icon : "mdi-domain" }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ child.name }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list-group>
          <router-link :to="item.link" :key="item.text" v-else>
            <v-list-item link>
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
        </template>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Menu",
  data() {
    return {
      inactive: false
    };
  },
  props: {
    menu: {
      type: Array,
      required: true
    },
    itemIndex: {
      type: Number,
      required: false
    }
  },
  computed: {
    ...mapGetters(["isAdmin"])
  },
  methods: {
    changeItem(index) {
      this.$emit("changeBlock", index);
    }
  }
};
</script>
